import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../../api/endpoints/dashboard';
import { DashboardQueryParams } from '../../api/types/dashboard.types';

/**
 * Custom hook to fetch dashboard data
 */
export const useDashboardData = (params?: DashboardQueryParams) => {
  return useQuery({
    queryKey: ['dashboard', params],
    queryFn: () => dashboardApi.getDashboardData(params),
    staleTime: 1000 * 60 * 2, // 2 minutes
    refetchInterval: 1000 * 60 * 5, // Auto-refetch every 5 minutes
    refetchOnWindowFocus: true,
  });
};

/**
 * Custom hook to fetch recent activities
 */
export const useRecentActivities = () => {
  return useQuery({
    queryKey: ['dashboard-activities'],
    queryFn: () => dashboardApi.getRecentActivities(),
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
};

/**
 * Custom hook to fetch chart data
 */
export const useChartData = () => {
  return useQuery({
    queryKey: ['dashboard-charts'],
    queryFn: () => dashboardApi.getChartData(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

/**
 * Custom hook to fetch alerts
 */
export const useAlerts = () => {
  return useQuery({
    queryKey: ['dashboard-alerts'],
    queryFn: () => dashboardApi.getAlerts(),
    staleTime: 1000 * 60 * 1, // 1 minute
    refetchInterval: 1000 * 60 * 2, // Auto-refetch every 2 minutes
  });
};
